import { get, post, patch, remove } from '@/helpers/httpHandler';

export default {
  retrievePerson: (_, person) =>
    get(`/persons/${person}`).then(response => {
      return response.data;
    }),

  store: (_, person) => post('/persons', person),

  update: (_, data) => patch(`/persons/${data.person.id}`, data),

  retrievePersons(_, { params } = {}) {
    return get(`/persons`, params);
  },

  filterUsersForNotification: (_, filter) =>
    post('/filter-users-for-notification', filter),

  retrievePersonsByRole: (_, role) => get(`persons-by-role/${role}`),

  storeRelatedPerson: (_, person) => post('/related-persons', person),

  retrieveInhabitantHistory: (_, personId) =>
    get(`/persons/${personId}/inhabitant-history`),

  livesWith: () => get('/lives-with'),

  getStatuses: () => get('/persons/statuses'),

  getOrders: (_, { personId, params }) =>
    get(`/persons/${personId}/orders`, params),

  getFilteredPersons(_, params) {
    return get('filters/persons', params);
  },

  getSalutations: () => get('/persons/salutations'),

  getGenders: () => get('/persons/genders'),

  getMaritalStatuses: () => get('/persons/marital-statuses'),

  getPersonNotruf: (_, personId) =>
    get(`/persons/${personId}/actual-notruf-subscription`),

  getAddressesTypes: () => get(`/persons/addresses/types`),

  getAddresses: (_, { personId, params }) =>
    get(`/persons/${personId}/addresses`, params),

  getAddress: (_, { personId, addressId }) =>
    get(`/persons/${personId}/addresses/${addressId}`),

  storeAddress: (_, { personId, address }) =>
    post(`/persons/${personId}/addresses`, address),

  updateAddress: (_, { personId, addressId, address }) =>
    patch(`/persons/${personId}/addresses/${addressId}`, address),

  getLinkedAddresses: (_, { personId, params }) =>
    get(`/persons/${personId}/addresses/linked`, params),

  getLinkedAddress: (_, { personId, addressId }) =>
    get(`/persons/${personId}/addresses/linked/${addressId}`),

  storeLinkedAddress: (_, { personId, address }) =>
    post(`/persons/${personId}/addresses/linked`, address),

  updateLinkedAddress: (_, { personId, addressId, address }) =>
    patch(`/persons/${personId}/addresses/linked/${addressId}`, address),

  deleteLinkedAddress: (_, { personId, addressId }) =>
    remove(`/persons/${personId}/addresses/linked/${addressId}`),

  storeSubscription(_, { personId, subscription }) {
    return post(`persons/${personId}/subscription`, subscription);
  },

  retrievePersonInterests: (_, id) => get(`/persons/${id}/interests`)
};
